import { render, staticRenderFns } from "./industryConfiguration.vue?vue&type=template&id=60f65b4e&"
import script from "./industryConfiguration.vue?vue&type=script&lang=js&"
export * from "./industryConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports